import {SET_AUTOCOMPLETE_PRODUCTS, SET_EQUIVALENCE, SET_PRODUCT, SET_PRODUCTS} from "../actions/product";

const initialState = {
    products: [],
    autocompleteProducts: [],
    product: null,
    equivalences: []
};

export default (state=initialState, action) => {
    switch(action.type) {
        case SET_PRODUCTS:
            return Object.assign({}, state, {
                products: action.payload
            });

        case SET_AUTOCOMPLETE_PRODUCTS:
            return Object.assign({}, state, {
                autocompleteProducts: action.payload
            });

        case SET_EQUIVALENCE:
            return Object.assign({}, state, {
                equivalences: action.payload
            });

        case SET_PRODUCT:
            return Object.assign({}, state, {
                product: action.payload
            });

        case 'REMOVE_PRODUCT_FROM_LIST':
            return Object.assign({}, state, {
                products: state.products.filter(product => product.id !== action.payload)
            });

        default:
            return state;
    }
}